import React from 'react';
import {useFetchEmployment, useFetchIdentificationInfo} from '@rocket-ui/lk-api';
import {hasActiveEmploymentStatus, isAlfaAgreementSent} from 'features/registration';
import {resolveCompleteRegistrationEdit, useProfile} from '../../model';
import {AlfaPersonalDataConsentBanner} from '../AlfaPersonalDataConsentBanner';
import {CompleteRegistrationBanner} from '../CompleteRegistrationBanner';
import {IdentityVerificationPendingBanner} from '../IdentityVerificationPendingBanner';
import {IdentityVerificationRejectedBanner} from '../IdentityVerificationRejectedBanner';

interface ProfileAlertsBannerProps {
	className?: string;
}

export function ProfileAlertsBanner({className}: ProfileAlertsBannerProps): React.ReactElement | null {
	const {fullInfo, isIdentityVerificationPending, isIdentityVerificationRejected, isSuccess} = useProfile();
	const identificationInfo = useFetchIdentificationInfo();
	const {data: employment, isLoading: isEmploymentLoading} = useFetchEmployment();
	const showAlfaPersonalDataConsent = isAlfaAgreementSent(employment);
	const completeRegistrationEdit =
		isSuccess && identificationInfo.isSuccess
			? resolveCompleteRegistrationEdit(
					identificationInfo.data,
					fullInfo,
					hasActiveEmploymentStatus(employment),
				)
			: null;
	const showCompleteRegistrationBanner = !isEmploymentLoading && completeRegistrationEdit !== null;

	const banner = showAlfaPersonalDataConsent ? (
		<AlfaPersonalDataConsentBanner />
	) : isIdentityVerificationRejected ? (
		<IdentityVerificationRejectedBanner />
	) : isIdentityVerificationPending ? (
		<IdentityVerificationPendingBanner />
	) : showCompleteRegistrationBanner ? (
		<CompleteRegistrationBanner edit={completeRegistrationEdit ?? 'statuses'} />
	) : null;

	if (!banner) {
		return null;
	}

	return <div className={className ?? 'mb-8'}>{banner}</div>;
}
